import { render, staticRenderFns } from "./CreateDriverPage.vue?vue&type=template&id=7e5fa1a2"
import script from "./CreateDriverPage.vue?vue&type=script&lang=js"
export * from "./CreateDriverPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports